import { combineReducers } from "redux";
import { callReducer } from "../reducer/callReducer";
import { callUserDetails } from "../reducer/callUserDetails";
import { loginReducer } from "../reducer/loginReducer";
import { flowReducer } from "../reducer/flowReducer";
import { commonReducer } from "../reducer/commonloading";
// import { chatReducer } from "../reducer/chatReducer";
import { initialSetupReducer } from "../reducer/initialSetupReducer";
import { chatConfiguration } from "../reducer/chatConfiguration";
import { reportReducer } from "../reducer/reportReducer";
import { agentTimerReducer } from "../reducer/agentTimerReducer";
import { meetingReducer } from "../reducer/meetReducer";
import { storeVideo } from "../reducer/storeVideo";
import { mediaDeviceInfo } from "../reducer/mediaDeviceInfo";
import { userAgent } from "../reducer/userAgent";

const appReducers = combineReducers({
  loginReducer,
 // chatReducer,
  callReducer,
  callUserDetails,
  flowReducer,
  commonReducer,
  initialSetupReducer,
  chatConfiguration,
  reportReducer,
  agentTimerReducer,
  // storeVideo,
  // meetingReducer,
  // mediaDeviceInfo,
  // userAgent
});

const rootReducers = (state: any, action: any) => {
  if (action.type === "USER_LOGOUT") {
    return appReducers(undefined, action);
  }
  return appReducers(state, action);
};

export default rootReducers;
